import {
    defaultBrandFilterFacets,
    getBrandsFilters,
} from 'common/api/search/getBrandsByCategoryName';
import { BrandsSearchFacet } from 'common/api/search/models/filters/BrandsSearchFacets';
import { facetPOST } from 'common/utils/searchFilters';
import { toPascalCase } from 'common/utils/strings';
import { useEffect, useState } from 'react';

export const useCategories = () => {
    const [categories, setCategories] = useState<string[]>([]);

    useEffect(() => {
        const defaultFacets = [
            ...defaultBrandFilterFacets,
            facetPOST(toPascalCase(BrandsSearchFacet.IsShipToHomeEligible)),
        ];
        getBrandsFilters({ facets: defaultFacets }).then((response) => {
            const categories = (response?.data?.searchFacets?.categories || []).map((c) => c.value);
            setCategories(categories as string[]);
        });
    }, []);

    return categories;
};
